<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-info">
          <form @submit.prevent class="form-horizontal">
            <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
            <div class="box-body">
              <div class="box no-border">
                <div class="col-md-8">                    
                  <div class="form-group">
                    <label for="inputName">Role</label>
                    <select v-model="formData.roleId" class="form-control" disabled>
                      <option v-for="(row, i) in listRole" v-bind:key="i" v-bind:value="row.id">
                        {{ row.name }}
                      </option>
                    </select>                       
                  </div>
                  <div class="form-group">
                    <label for="inputAuthObject">Authorization Object</label>
                    <select id="inputAuthObject"  v-model="formData.authObjectId" class="form-control" disabled>
                      <option v-for="(row, i) in listAuthObject" v-bind:key="i" v-bind:value="row.id" v-bind:name="row.name">
                        {{ row.name }}
                      </option>
                    </select>                       
                  </div>
                  <div class="form-group">
                    <label for="inputAuthField">Authorization Field</label>
                    <select id="inputAuthField" v-model="formData.authObjectFieldId" class="form-control" :disabled="viewMode == MODE_VIEW" @change="onChangeAuthorizationField($event)">
                      <option v-for="(row, i) in listAuthObjectField" v-bind:key="i" v-bind:value="row.id" v-bind:authFieldId="row.authFieldId" v-bind:authFieldName="row.authFieldName">
                        {{ row.authFieldName }}
                      </option>
                    </select>                       
                  </div>
                  <div class="form-group">
                    <label for="inputAuthValue">Authorization Value</label>
                    <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputAuthValue" placeholder="Authorization Value" v-model="formData.value">                       
                  </div>
                </div>
              </div>                          
            </div>
            <!-- /.box-body -->

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                <button @click="onCancel()" class="btn btn-warning">Cancel</button>
                <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button>
              </div>
            </div>
            <!-- /.box-footer -->
          </form>
        </div>          
      </div>
    </div> 
  </div>  
</template>

<script>
import api from '../../api'
import SweetAlert from 'sweetalert2'

const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'

export default {
  name: 'RoleAuthObjectFieldForm',
  data() {
    return {
      MODE_NONE: MODE_NONE,
      MODE_CREATE: MODE_CREATE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        roleAuthObjectId: 0,
        authObjectFieldId: 0,
        authObjectId: 0,
        authFieldId: 0,
        authObjectName: '',
        authFieldName: '',
        value: '',
        roleId: 0
      },
      listRole: null,
      listAuthObject: null,
      listAuthObjectField: null,
      callback: undefined
    }
  },
  created() {
    if (this.$route.params) {
      this.callback = this.$route.params.callback
      this.formData.id = this.$route.params.id
      this.formData.roleId = this.$route.params.roleId
      this.formData.roleAuthObjectId = this.$route.params.roleAuthObjectId
      this.formData.authObjectId = this.$route.params.authObjectId
      this.viewMode = this.$route.params.mode
    }

    this.getDetail()
  },
  mounted() {
  },
  methods: {
    getDetail() {
      if (this.formData.id && this.formData.id !== 0) {
        api
          .request('Account', 'get', '/api/Role/GetDetailRoleAuthObjectField?Id=' + this.formData.id, null)
          .then(response => {
            var data = response.data
            this.formData.roleAuthObjectId = data.entity.roleAuthObjectId
            this.formData.authObjectFieldId = data.entity.authObjectFieldId
            this.formData.authObjectId = data.entity.authObjectId
            this.formData.authFieldId = data.entity.authFieldId
            this.formData.authObjectName = data.entity.authObjectName
            this.formData.authFieldName = data.entity.authFieldName
            this.formData.value = data.entity.value
          })
          .then(response => {
            this.getRole()
            this.getAuthObject()
            this.getAuthObjectField()
          })
          .catch(error => {
            var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
            SweetAlert.fire('Error', message, 'error')
          })
      } else {
        this.getRole()
        this.getAuthObject()
        this.getAuthObjectField()
      }
    },
    getRole() {
      api
        .request('Account', 'get', '/api/Role/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listRole = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getAuthObject() {
      api
        .request('Account', 'get', '/api/Role/InquiryAllAuthObject', null)
        .then(response => {
          var data = response.data
          this.listAuthObject = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getAuthObjectField() {
      api
        .request('Account', 'get', '/api/Role/InquiryAuthObjectField?WhereClause=AuthObjectId = ' + this.formData.authObjectId +
                                 '&PageSize=999999&CurrentPageNumber=1&SortDirection=ASC&SortExpression=Id', null)
        .then(response => {
          var data = response.data
          this.listAuthObjectField = data.entity
          console.log(response.data)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      this.formData.id = 0
      this.formData.roleId = 0
      this.formData.authObjectId = 0
    },
    onCreate() {
      this.initForm()
      this.viewMode = MODE_CREATE
    },
    onEdit() {
      this.viewMode = MODE_UPDATE
    },
    onDisplay() {
      this.viewMode = MODE_VIEW
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      let name = this.callback[this.callback.length - 1].name
      let id = this.callback[this.callback.length - 1].id
      let mode = this.callback[this.callback.length - 1].mode
      this.callback.splice(this.callback.length - 1, 1)
      let params = {
        id: id,
        mode: mode,
        callback: this.callback
      }
      this.$router.push({ name: name, params: params })
    },
    onChangeAuthorizationField(evt) {
      this.formData.authFieldId = window.$('#inputAuthField option:selected').attr('authFieldId')
      this.formData.authFieldName = window.$('#inputAuthField option:selected').attr('authFieldName')
      this.formData.authObjectFieldId = evt.target.value
      this.formData.authObjectName = window.$('#inputAuthObject option:selected').attr('name')
      this.formData.value = ''
    },
    onSave() {
      var data = {
        Id: this.formData.id,
        RoleAuthObjectId: this.formData.roleAuthObjectId,
        AuthObjectFieldId: this.formData.authObjectFieldId,
        AuthObjectId: this.formData.authObjectId,
        AuthObjectName: this.formData.authObjectName,
        AuthFieldId: this.formData.authFieldId,
        AuthFieldName: this.formData.authFieldName,
        Value: this.formData.value
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Account', 'post', '/api/Role/' + method + 'RoleAuthObjectField', data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.onDisplay()
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}
</style>



// WEBPACK FOOTER //
// RoleAuthObjectFieldForm.vue?61cdc919